import React from 'react';
import { Checkbox, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { checkboxConfig } from '../PermissionType';

interface PermissionCheckboxesProps {
    checkedItems: Record<string, boolean>;
    onCheckboxChange: (e: any) => void;
}

const PermissionAccessDetail: React.FC<PermissionCheckboxesProps> = ({ checkedItems, onCheckboxChange }) => {
    return (
        <>
            {checkboxConfig.map((checkbox) => (
                <div className="check-block" key={checkbox.name}>
                    <div className="checkbox-container">
                        <Checkbox
                            name={checkbox.name}
                            checked={checkedItems[checkbox.name]}
                            onChange={onCheckboxChange}
                            onClick={(e) => e.stopPropagation()} // Prevent click propagation to container
                        />
                        <span style={{ marginLeft: 8 }}>{checkbox.label}</span>
                        <Tooltip placement="right" title={checkbox.tooltip}>
                            <InfoCircleOutlined style={{ marginLeft: 5 }} />
                        </Tooltip>
                    </div>
                </div>
            ))}
        </>
    );
};

export default PermissionAccessDetail;
